import React from 'react';
import { RocheTextLinkTypes } from './roche-text-link';
import { RocheUITextLink } from '@repo/roche-ui';

const showOnetrustSettings = (): void => (window as any).OneTrust?.ToggleInfoDisplay();

export const RocheCookieBannerLink = ({
  blok: { text, target, right_icon: rightIcon, left_icon: leftIcon, type },
  slot,
}: RocheTextLinkTypes): JSX.Element => (
  <RocheUITextLink
    slot={slot}
    target={target}
    leftIcon={leftIcon}
    rightIcon={rightIcon}
    text={text}
    onButtonClick={showOnetrustSettings}
    type={type}
  />
);
